export default "__VITE_ASSET__rQleh7bM__"